import { render } from "./WorkOrderDetail.vue?vue&type=template&id=588e59a8"
import script from "./WorkOrderDetail.vue?vue&type=script&lang=js"
export * from "./WorkOrderDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__